<div class="pr-2 pl-2 d-flex justify-content-between">
    <input type="text"   placeholder="Search Order ID, Customer , Category , Card"  class="form-control col-lg-4 mt-1"
        (keyup)="updateFilter($event)"   />
    
</div>
<br>
<ngx-datatable class="material" [rows]="orderList" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
    style="position: relative !important;">
    <ngx-datatable-column [flexGrow]="1" name="Order ID" prop="oGuidanceId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            #{{row.oGuidanceId}}
        </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column [flexGrow]="2" name="Customer" prop="astroId.name">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row?.customerId?.name}}</span>
        </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column [flexGrow]="1" name="Amount">
        <ng-template let-row="row" ngx-datatable-cell-template>

            <span>{{row?.customerCurrencySymbol}}{{row?.company_amount |number : '.2-2'}}</span>

        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" name="Category" prop="guidanceCategoryName">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row?.guidanceCategoryName}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" name="Card" prop="guidanceCardName">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row?.guidanceCardName}}</span>
        </ng-template>
    </ngx-datatable-column>




    <ngx-datatable-column [flexGrow]="2" name="Status" prop="order_current_status">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row?.order_current_status}}</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" name="Date" prop="created_at">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.created_at |date :'medium'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="1" name="Action">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <a [routerLink]="['/admin/orders/guidance',row._id]" title="View Details"><i class="fa fa-eye"></i></a>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>